// extracted by mini-css-extract-plugin
export default {"root":"Spinner__root--2ThLn","spin":"Spinner__spin--JlTLN","root_embedded":"Spinner__root_embedded--i7r6G"};